var he = Object.defineProperty;
var ve = (e, t, s) => t in e ? he(e, t, { enumerable: !0, configurable: !0, writable: !0, value: s }) : e[t] = s;
var p = (e, t, s) => ve(e, typeof t != "symbol" ? t + "" : t, s);
const Ge = (e = "", t = 10) => {
  const s = new Uint8Array(t);
  crypto.getRandomValues(s);
  const r = Array.from(s).map((n) => n.toString(16).padStart(2, "0")).join("").slice(0, t);
  return e !== "" ? `${e}-${r}` : r;
}, Xe = (e) => me(e) && /^([a-z][a-z0-9]*)(-[a-z0-9]+)*$/.exec(e) !== null;
class Ze {
  constructor(t = []) {
    /**
     * Available classes
     */
    p(this, "classes");
    /**
     * Add class
     * @param className - class name to add
     */
    p(this, "add", (t) => {
      this.has(t) || this.classes.push(t);
    });
    /**
     * Delete class
     * @param className - class name to delete
     */
    p(this, "delete", (t) => {
      const s = this.classes.indexOf(t);
      s > -1 && this.classes.splice(s, 1);
    });
    /**
     * Check if class exist in list
     * @param className - class name to check
     * @returns class name is in the list
     */
    p(this, "has", (t) => this.classes.includes(t));
    /**
     * Join classes seperated by spaces
     * @returns joined values
     */
    p(this, "join", () => this.classes.join(" "));
    this.classes = t;
  }
}
const Je = (e) => Array.isArray(e) && e.every((t) => typeof t == "string"), Ke = (e, t) => t.includes(e == null ? void 0 : e.tagName.toLowerCase()), Qe = 'a[href], button, input, textarea, select, details, [tabindex]:not([tabindex="-1"]), [identifier], mg-button', Ye = (e) => {
  const t = Y(e), s = V(e);
  return [e, ...t, ...s];
}, Y = (e, t = []) => {
  if (e.self !== e.top)
    try {
      const s = e.parent;
      return s ? (t.push(s), Y(s, t)) : t;
    } catch (s) {
      return console.error("Different hosts between iframes:", s), t;
    }
  return t;
}, V = (e, t = []) => {
  if (e.frames.length > 0)
    for (const s of Array.from(e.frames))
      t.push(s), V(s, t);
  return t;
}, me = (e) => typeof e == "string" && e.trim() !== "", Ve = (e) => typeof e == "object" ? JSON.stringify(e) : `${e}`, et = (e) => typeof e == "number" && !Number.isNaN(e), tt = (e) => typeof e == "string" ? e.toLocaleLowerCase().normalize("NFD").replaceAll(/[\u0300-\u036f]/g, "") : e, st = async (e) => e();
var be = Object.defineProperty, Se = (e, t) => {
  for (var s in t)
    be(e, s, { get: t[s], enumerable: !0 });
}, _e = {};
Se(_e, {
  err: () => se,
  map: () => Ee,
  ok: () => P,
  unwrap: () => Ae,
  unwrapErr: () => je
});
var P = (e) => ({
  isOk: !0,
  isErr: !1,
  value: e
}), se = (e) => ({
  isOk: !1,
  isErr: !0,
  value: e
});
function Ee(e, t) {
  if (e.isOk) {
    const s = t(e.value);
    return s instanceof Promise ? s.then((r) => P(r)) : P(s);
  }
  if (e.isErr) {
    const s = e.value;
    return se(s);
  }
  throw "should never get here";
}
var Ae = (e) => {
  if (e.isOk)
    return e.value;
  throw e.value;
}, je = (e) => {
  if (e.isErr)
    return e.value;
  throw e.value;
};
const ft = (e) => {
  const t = { value: "2023", pattern: "yyyy" }, s = { value: "12", pattern: "mm" }, r = { value: "24", pattern: "dd" };
  return ze([t.value, s.value, r.value].join("-"), e, { timeZone: "UTC" }).replace(t.value, t.pattern).replace(s.value, s.pattern).replace(r.value, r.pattern);
}, $t = (e) => e.toISOString().split("T")[0], Pe = (e, t, s) => {
  const r = e.closest("[lang]"), n = Intl.NumberFormat.supportedLocalesOf(r == null ? void 0 : r.lang), i = n.length > 0 && typeof n[0] == "string" ? n[0] : navigator.language || s, o = i.split("-").shift();
  return Object.keys(t).length === 0 ? {
    locale: i,
    messages: { lang: s }
  } : {
    locale: i,
    messages: t[o] || t[s] || { lang: s }
  };
}, ut = (e, t, s) => new Intl.NumberFormat(t, { style: "currency", currency: s }).format(e), dt = (e, t, s = 0) => new Intl.NumberFormat(t, { minimumFractionDigits: s }).format(s > 0 ? Number(e == null ? void 0 : e.toFixed(s)) : e), gt = (e, t, s = 0) => new Intl.NumberFormat(t, {
  style: "percent",
  minimumFractionDigits: s,
  maximumFractionDigits: s
}).format(e), pt = (e, t, s, r = "short", n = 0) => new Intl.NumberFormat(t, {
  style: "unit",
  unit: s,
  unitDisplay: r,
  minimumFractionDigits: n,
  maximumFractionDigits: n
}).format(e), we = /^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])$/, ze = (e, t, s) => typeof e != "string" || e === "" || !we.test(e) ? "" : new Intl.DateTimeFormat(t, s).format(new Date(e)), ht = (e, t) => (s) => Pe(s, e, t);

export { $t as $, Ge as G, Je as J, Ke as K, Qe as Q, Ve as V, Xe as X, Ye as Y, Ze as Z, dt as d, et as e, ft as f, gt as g, ht as h, me as m, pt as p, st as s, tt as t, ut as u, we as w, ze as z };

//# sourceMappingURL=index.es-b80b758c.js.map